import { FunctionComponent, useMemo } from 'react';
import { createPortal } from 'react-dom';
import {
  FullscreenCloseButton,
  FullscreenCloseButtonWrapper,
  FullscreenContent,
  FullscreenPanel,
  StyledFullscreen,
} from './Fullscreen.styled';
import { FullscreenProps } from './types';

export const Fullscreen: FunctionComponent<FullscreenProps> = props => {
  const { children, expanded, onClose } = props;

  // Get reference to the parent element of the side panel
  const parentElement = useMemo(() => document.getElementById('root') ?? document.body, []);

  if (!expanded) {
    return <>{children}</>;
  }

  return createPortal(
    <StyledFullscreen>
      <FullscreenPanel>
        <FullscreenCloseButtonWrapper>
          <FullscreenCloseButton onClick={onClose} />
        </FullscreenCloseButtonWrapper>
        <FullscreenContent>{children}</FullscreenContent>
      </FullscreenPanel>
    </StyledFullscreen>,
    parentElement,
  );
};
